<script>
    import {Utils, $} from '../../app.base'
    import {Vue, PopperJS, zIndexManager} from '../../app.vues'
    //
    let allowedPopTriggerNames = ['click', 'hover', 'manual'];//, 'focus'
    let default_popover_position = 'bottom-start';
    let set_popover_info = function (el, binding) {
        //console.log(' bind ------- ' + el.name);
        let propName = binding.arg;
        let propValue = binding.value;
        if (propName == 'is') {//popover ref name
            if (typeof propValue == 'undefined') {
                propValue = binding.expression;
            }
            el.popover_is = propValue || null;
            return;
        }
        if (propName == 'at') {//placement
            if (typeof propValue != 'string') {
                propValue = binding.expression;
            }
            el.popover_at = propValue || null;
            return;
        }
        if (propName == 'tag') {
            if (typeof propValue == 'undefined') {
                propValue = binding.expression;
            }
            el.popover_tag = propValue;
            return;
        }
        //
        if (propName == 'on') {//trigger
            if (el.popover_bound_on_ts != null) {
                //console.debug('bound popover at ' + el.popover_bound_on_ts);
                return;
            }
            //
            if (typeof propValue != 'string') {
                propValue = binding.expression;
            }
            if (allowedPopTriggerNames.indexOf(propValue) == -1) {
                propValue = null;
            }
            let trigger = propValue || 'click';
            el.popover_on = trigger;
            //
            el.popover_bound_on_ts = new Date().getTime();
            //
            let jqEl = $(el);
            let vueParent = el.__vue__.$parent;
            if (trigger == 'hover') {
                jqEl.bind('mouseenter', function () {
                    let popRef = typeof el.popover_is == 'string' ? vueParent.$refs[el.popover_is] : el.popover_is;
                    if (popRef != null) {
                        el.__popRef = popRef;
                        let tag = el.popover_tag;
                        let placement = el.popover_at || default_popover_position;
                        popRef.bindToReferer(el, 'hover', {
                            showNow: true,
                            placement: placement,
                            tag: tag
                        });
                    }
                });
            } else {//click
                jqEl.bind('click', function () {
                    let popRef = typeof el.popover_is == 'string' ? vueParent.$refs[el.popover_is] : el.popover_is;
                    if (popRef != null) {
                        el.__popRef = popRef;
                        let tag = el.popover_tag;
                        let placement = el.popover_at || default_popover_position;
                        popRef.bindToReferer(el, 'click', {
                            showNow: true,
                            placement: placement,
                            tag: tag
                        });
                    }
                });
            }
        }

    };

    let del_popover_info = function (el, binding) {
        //console.log('unbind  - ' + el.name);
        let popRef = el.__popRef;
        if (popRef != null) {
            popRef.$destroy();
            delete el.__popRef;
            console.info('关联的popover已销毁');
        }
        //
        delete el.popover_is;
        delete el.popover_at;
        delete el.popover_tag;
        delete el.popover_on;
        delete el.popover_bound_on_ts;
        delete el.popover_is;
        delete el.popover_is;
        //
        let jqEl = $(el);
        jqEl.unbind();
        $(el).remove();
        //console.log('removed - ' + el.name);
    };
    //vuehtml标签指令对象
    //<el-button v-dt-popover:is="popoverRef" v-dt-popover:on="hover" v-dt-popover:tag="456" v-dt-popover:at="bottom-start">XXX</el-button>
    Vue.directive('dt-popover', {
        bind: set_popover_info,
        update: set_popover_info,
        unbind: del_popover_info
    });

    export default {//此组件与element-ui仅有样式引用关系
        name: 'swb-dt-popover',
        desc: '可动态粘附在不同元素上的的Popover',
        template: '<span>\n' +
            '        <div class="el-popover el-popper dt-popover" :id="popperId" ref="popperRef" :class="classes" v-show="!disabled && showPopper" :style="{ width: width + \'px\' , \'z-index\' : popperZIndex}" role="tooltip"\n' +
            '             :aria-hidden="(disabled || !showPopper) ? \'true\' : \'false\'">\n' +
            '            <div class="el-popover__title" v-if="title" v-text="title"></div>\n' +
            '            <slot>{{ content }}</slot>\n' +
            '        </div>\n' +
            '    </span>',
        props: {
            transformOrigin: {
                type: [Boolean, String],
                default: true
            },
            trigger: {//触发事件
                type: String,
                default: 'click',
                validator: function (value) {
                    return allowedPopTriggerNames.indexOf(value) > -1;
                }
            },
            reference: {//触发元素
                default: null
            },
            value: Boolean,
            placement: {//top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
                default: default_popover_position
            },
            title: {
                default: ''
            },
            content: {
                default: ''
            },
            disabled: {
                default: false
            },
            openDelay: {
                type: Number,
                default: 100
            },
            closeDelay: {
                type: Number,
                default: 200
            },
            tag: {//自定义数据
                default: null
            },
            appendToBody: {
                type: Boolean,
                default: true
            },
            width: {
                default: null
            },
            classes: {
                default: function () {
                    return [];
                }
            },
            offset: {
                default: 0
            },
            visibleArrow: {
                default: true
            },
            arrowOffset: {
                default: 0
            }
        },
        watch: {
            value: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    this.showPopper = newVal;
                    this.$emit('input', newVal);
                }
            },
            reference: function (newVal, oldVal) {
                this.bindToReferer(this.reference, null);
            },
            trigger: function (newVal, oldVal) {
                this.bindToReferer(null, this.trigger);
            },
            placement: function (newVal, oldVal) {
                this.curPlacement = this.placement;
                this.bindToReferer(null, null);
            },
            tag: function (newVal, oldVal) {
                this.curTag = this.tag;
            },
            showPopper: function (newVal, oldVal) {
                if (this.disabled) {
                    return;
                }
                if (newVal) {
                    this.popperZIndex = zIndexManager.nextZIndex(true);
                    //
                    this.$emit('show', this.curTag)
                } else {
                    this.$emit('hide', this.curTag);
                }
            }
        },
        data: function () {
            return {
                popperId: null,
                popperZIndex: zIndexManager.nextZIndex(true),
                showPopper: false,
                //
                curReferer: null,//dom
                selfPopper: null,//dom
                //
                popperInst: null,
                //
                curTrigger: null,
                curPlacement: null,
                curTag: null
            };
        },
        created: function () {
            this.popperId = 'dt-popover-' + Utils.genUniqueStr();
        },
        mounted: function () {
            this.curTrigger = this.trigger;
            this.curPlacement = this.placement;
            this.curTag = this.tag;
            //
            $(document).bind('click', this.handleDocClick);
            //
            this.selfPopper = this.$refs['popperRef'];
            if (this.visibleArrow) {
                this.appendArrow(this.selfPopper);
            }
            if (this.appendToBody) {
                document.body.appendChild(this.selfPopper);
            }
            //
            this.bindToReferer(null, null);
        },
        beforeDestroy: function () {
            this.doClear(true);
            $(document).unbind('click', this.handleDocClick);
        },
        methods: {
            appendArrow: function (element) {
                let hash;
                if (this.arrowAppended) {
                    return;
                }

                this.arrowAppended = true;

                for (let item in element.attributes) {
                    if (/^_v-/.test(element.attributes[item].name)) {
                        hash = element.attributes[item].name;
                        break;
                    }
                }

                const arrow = document.createElement('div');

                if (hash) {
                    arrow.setAttribute(hash, '');
                }
                arrow.setAttribute('x-arrow', '');
                arrow.className = 'popper__arrow';
                element.appendChild(arrow);
            },
            handleDocClick: function (evnt) {
                if (this.curTrigger == 'manual') {
                    return;
                }
                //
                let curReferer = this.curReferer;
                let selfPopper = this.selfPopper;
                if (!this.$el || this.$el.contains(evnt.target) ||
                    !curReferer || curReferer.contains(evnt.target) ||
                    !selfPopper || selfPopper.contains(evnt.target)) return;
                //
                this.showPopper = false;
            },
            doClear: function (forTheEnd) {
                if (typeof forTheEnd === 'undefined') {
                    forTheEnd = false;
                }
                clearTimeout(this._timer);
                this.doHide();
                //解除旧的绑定
                if (this.popperInst != null) {
                    this.popperInst.destroy();
                    this.popperInst = null;
                }
                let curReferer = this.curReferer;
                if (curReferer != null) {
                    this.curReferer = null;
                    curReferer.removeAttribute('aria-describedby');
                    //
                    $(curReferer).unbind('click', this.doToggle);

                    $(curReferer).unbind('mouseenter', this.handleMouseEnter);
                    $(curReferer).unbind('mouseleave', this.handleMouseLeave);
                }
                if (forTheEnd) {
                    if (this.selfPopper != null) {
                        this.selfPopper.parentNode.removeChild(this.selfPopper);
                        this.selfPopper = null;
                    }
                    //
                    this.curTag = null;
                    this.reference = null;
                }
            },
            updatePopper: function () {
                const popperInst = this.popperInst;
                if (popperInst) {
                    popperInst.update();
                }
            },
            bindToReferer: function (reference, trigger, extraInfo) {
                extraInfo = extraInfo || {};
                let placement = extraInfo.placement || this.curPlacement;
                let tag = extraInfo.tag;
                if (typeof tag == 'undefined') {
                    tag = this.curTag;
                }
                let showNow = extraInfo.showNow || false;
                //
                reference = reference || this.reference;
                trigger = trigger || this.curTrigger;
                //
                let newReferer = reference;
                if (newReferer != null) {
                    if (typeof newReferer == 'string') {
                        newReferer = $(newReferer);
                        if (newReferer.length > 0) {
                            newReferer = newReferer.get(0);
                        } else {
                            console.warn('指定的vue组件或html元素无效');
                            return;
                        }
                    }
                    if (newReferer.$el != null) {
                        newReferer = newReferer.$el;
                    }
                    if (!newReferer.tagName) {
                        console.warn('指定的vue组件或html元素无效');
                        return;
                    }
                }
                //
                this.curPlacement = placement;
                this.curTag = tag;
                if (newReferer == this.curReferer) {
                    if (placement != this.curPlacement) {
                        console.log('同一个没变，但');
                        console.log('位置：' + this.curPlacement + ' => ' + placement);
                    }
                    return;
                }
                this.curTrigger = trigger;
                //
                this.doClear();
                //
                if (newReferer != null) {
                    this.curReferer = newReferer;
                    newReferer.setAttribute('aria-describedby', this.popperId);
                    //
                    if (this.curTrigger == 'click') {
                        $(newReferer).bind('click', this.doToggle);
                    } else if (this.curTrigger == 'hover') {
                        $(newReferer).bind('mouseenter', this.handleMouseEnter);
                        $(newReferer).bind('mouseleave', this.handleMouseLeave);
                    }
                    //...

                    let options = {};
                    options.placement = this.curPlacement;
                    options.offset = this.offset;
                    options.arrowOffset = this.arrowOffset;
                    this.popperInst = new PopperJS(this.curReferer, this.selfPopper, options);

                    let self = this;
                    this.popperInst.onCreate(function () {
                        self.resetTransformOrigin();
                        self.$nextTick(self.updatePopper);
                        //
                        if (showNow && self.curTrigger != 'manual') {
                            self.doShow(true);
                        }
                    });
                }
            },
            resetTransformOrigin: function () {
                if (!this.transformOrigin) return;
                let placementMap = {
                    top: 'bottom',
                    bottom: 'top',
                    left: 'right',
                    right: 'left'
                };
                let placement = this.popperInst._popper.getAttribute('x-placement').split('-')[0];
                let origin = placementMap[placement];
                this.popperInst._popper.style.transformOrigin = typeof this.transformOrigin === 'string'
                    ? this.transformOrigin
                    : ['top', 'bottom'].indexOf(placement) > -1 ? `center ${origin}` : `${origin} center`;
            },
            doToggle: function () {
                this.showPopper = !this.showPopper;
            },
            handleMouseEnter: function () {
                clearTimeout(this._timer);
                if (this.openDelay) {
                    let self = this;
                    this._timer = setTimeout(function () {
                        self.showPopper = true;
                    }, this.openDelay);
                } else {
                    this.showPopper = true;
                }
            },
            handleMouseLeave: function () {
                clearTimeout(this._timer);
                if (this.closeDelay) {
                    let self = this;
                    this._timer = setTimeout(function () {
                        self.showPopper = false;
                    }, this.closeDelay);
                } else {
                    this.showPopper = false;
                }
            },
            doShow: function (withDelay) {
                if (typeof withDelay === 'undefined') {
                    withDelay = false;
                }
                if (withDelay && this.openDelay) {
                    //clearTimeout(this._timer);
                    let self = this;
                    this._timer = setTimeout(function () {
                        self.showPopper = true;
                    }, this.openDelay);
                } else {
                    this.showPopper = true;
                }
            },
            doHide: function () {
                this.showPopper = false;
            },
            //--------------------------------------------
            update: function () {//重新定位
                this.updatePopper();
            },
            show: function () {
                this.doShow();
            },
            hide: function () {
                this.doHide();
            },
            getTag: function () {
                return this.curTag;
            }
        }

    }
</script>
<style>
    .el-popover.el-popper.dt-popover {
        transition: all 0.3s linear;
    }

    .el-popover.el-popper.dt-popover.menu {
        border-radius: 0;
    }

    .el-popover.el-popper.dt-popover.drop-down.menu {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ctrl/DtPopover.vue